'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Switch } from '@sprd/sprd-component-kit/v2';
import { ChangeEvent, FC, useCallback } from 'react';
import { useTranslations } from 'next-intl';
import useLocalStorage from '@/hooks/useLocalStorage';
import { ProductCardProps } from '@/components/ProductCard/ProductCard';
import ProductSlider from '@/components/ProductSlider/ProductSlider';
import { TRACK_RECENTLY_KEY } from '@/components/RecentlyViewed/RecentlyViewedTracker';
type RecentlyViewedProps = {
  className?: string;
  items: ProductCardProps[];
  clearHistory: () => void;
};
const RecentlyViewed: FC<RecentlyViewedProps> = t0 => {
  const $ = _c(23);
  const {
    className,
    items,
    clearHistory
  } = t0;
  const t = useTranslations("recentlyViewed");
  const [trackRecently, setTrackRecently] = useLocalStorage(TRACK_RECENTLY_KEY, true);
  let t1;
  if ($[0] !== setTrackRecently) {
    t1 = event => setTrackRecently(event.target.checked);
    $[0] = setTrackRecently;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleRememberChange = t1;
  let t2;
  if ($[2] !== t) {
    t2 = t("title");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("remember");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== handleRememberChange || $[7] !== t3 || $[8] !== trackRecently) {
    t4 = <Switch checked={trackRecently} onChange={handleRememberChange} label={t3} labelPosition="left" />;
    $[6] = handleRememberChange;
    $[7] = t3;
    $[8] = trackRecently;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t) {
    t5 = t("clear");
    $[10] = t;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== clearHistory || $[13] !== t5) {
    t6 = <Button size="m" variant="ghost" onClick={clearHistory}>{t5}</Button>;
    $[12] = clearHistory;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t4 || $[16] !== t6) {
    t7 = <div className="mt-4 flex flex-wrap items-center justify-end gap-6 pr-4 xs:mt-8 sm:mt-9 sm:pr-6 md:mt-12 md:pr-8 lg:mt-15 lg:pr-16 xl:mt-22.5 xl:pr-22.5">{t4}{t6}</div>;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== className || $[19] !== items || $[20] !== t2 || $[21] !== t7) {
    t8 = <ProductSlider className={className} heading={t2} items={items} optimizeImages={true} deferAppearances={true} deferBadges={true}>{t7}</ProductSlider>;
    $[18] = className;
    $[19] = items;
    $[20] = t2;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  return t8;
};
export default RecentlyViewed;